/**
 * Extracts the UTC calendar date prefix (`YYYY-MM-DD`) from a `Date` whose
 * UTC components encode the intended calendar day (as produced by
 * `BrnUtcDateAdapter`).
 *
 * Using UTC getters (`getUTCFullYear` / `getUTCMonth` / `getUTCDate`) is
 * mandatory here: `BrnUtcDateAdapter` creates all dates via `Date.UTC(...)`,
 * so the UTC components are the canonical representation of the day. Local
 * getters would introduce a timezone shift on machines running behind UTC
 * (e.g. UTC-3), turning a pick of June 13 into June 12.
 *
 * @param date A `Date` object whose UTC components represent the chosen day.
 * @returns ISO date-prefix string `YYYY-MM-DD` in UTC.
 *
 * @example
 * const d = new Date(Date.UTC(2026, 5, 13)); // 2026-06-13 UTC midnight
 * utcDatePrefix(d); // → '2026-06-13'
 */
export function utcDatePrefix(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
